/*eslint no-extend-native: ["error", { "exceptions": ["Array"] }]*/
if(!Array.prototype.unique)
    Object.defineProperty(Array.prototype,'unique',{
        value:(function(){
			function distinct(value,index,self){
				return self.indexOf(value)===index;
			}
			return function(){
				return this.filter(distinct);
			}
		})()
	});

if(!Array.prototype.toObject)
    Object.defineProperty(Array.prototype,'toObject',{
        value:function(key_prop){
			const ret_data={};
			for(let i=0;i<this.length;i++)
				ret_data[this[i][key_prop || 'id']]=this[i];
			return ret_data;
		}
	});